import pluralize from "pluralize";
import UserUtils from "./UserUtils";

const TypeUtils = {
  displayName(type) {
    return type.collection ? pluralize(type.name) : type.name;
  },

  modelName(type) {
    if (TypeUtils.isUserRole(type)) {
      return "User Role";
    } else {
      return "Model";
    }
  },

  displayFields(type) {
    const options = type.options || {};
    let fields = options.display_fields || [];
    if (!fields.length && TypeUtils.isUserRole(type)) return ["email"];
    if (!fields.length) return [type.parts[0].name || false];
    if (!Array.isArray(fields)) {
      fields = [fields];
    }
    let definition = TypeUtils.definition(type);

    return fields.filter((field) => {
      return (
        !!definition[field] ||
        (TypeUtils.isUserRole(type) && field === "email") ||
        field === "date_created"
      );
    });
  },

  definition(type) {
    let initial = {};
    return type.parts.reduce((obj, partDefinition) => {
      obj[partDefinition.name] = partDefinition;
      return obj;
    }, initial);
  },

  can(role, type, action, id = false) {
    const permission = TypeUtils.permissionName(type, !!id);
    // reserved types cannot be deleted
    if (
      action === "delete" &&
      type.reserved &&
      (permission === "user_role" || permission === "content_type")
    ) {
      return false;
    }

    return UserUtils.can(role, action, permission, id);
  },

  permissionName(type, sub = false) {
    if (TypeUtils.isUserRole(type)) {
      return sub ? "user" : "user_role";
    }
    return sub ? "content" : "content_type";
  },

  isSettings(type) {
    return type.hasOwnProperty("settings");
  },

  isUserRole(type) {
    return type.hasOwnProperty("admin_access");
  },

  sortable(type) {
    const { sort_method } = type.options || { sort_method: false };
    return sort_method === "manual" || sort_method === "hierarchy"; // eslint-disable-line
  },

  section(type) {
    if (TypeUtils.isUserRole(type)) {
      return "users";
    }

    return "content";
  },

  url(site, type) {
    const section = TypeUtils.section(type);
    return `/${site.id}/${section}/${type.slug}`;
  },
};

export default TypeUtils;



// WEBPACK FOOTER //
// ./app/lib/TypeUtils.js